import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestLatePaymentFeeDetailsList(params) {
  return fetch.get(`${BASE_URL}/api/app/reports/latePaymentFeeNew?${params}`, {
    params: { 
      limit: Number.MAX_SAFE_INTEGER,
     page:1},
  });
}


export function requestCreateGenerateInvoice(params) {
  return fetch.post(
    `${BASE_URL}/api/app/invoice/createInvoiceWithItems`,
    params
  );
}
